<template>
    <div class="header-wrap">
        <div class="logo" @click="goRouter({ name: '首页', value: '' })">
            <img src="../../assets/images/logo2.png">
        </div>
        <div class="right-c">
            <div class="lg-c">
                <div class="la" @click="selectLanuage(item, index)" v-for="(item, index) in lanuageList"
                    :class="{ on: index === currentIndex }" :key="index">
                    {{ item.name }}
                </div>
            </div>
        
            <div style="display: flex;justify-content: flex-end;margin-top:.32rem">
                <div class="ico-more" @click="showPop = !showPop">
                </div>
            </div>
            
        </div>
        
        <transition name="slide-fade">
            <div class="link-c" v-if="showPop">
                <div class="item" v-for="(menu, index) in menuList" :key="index" @click="goRouter(menu)">{{ menu.name }}
                </div>
            </div>
        </transition>

    </div>
</template>
<script>

export default {
    name: 'MobileHeader',
    props: {
        lang: {},
        from:{
            type:String,
            default:''
        }
    },
    data() {
        return {
            lanuageList: [
                { name: '中文', value: 'zh' },
                { name: 'English', value: 'en' },
                { name: '日本語', value: 'ja' }
            ],
            menuList: [
                { name: '首页', value: '' },
                { name: '关于我们', value: '/about-mobile' },
                { name: '新闻中心', value: '/news-mobile' },
                { name: '联系我们', value: '/contact-mobile' },
            ],
            currentIndex: 0,
            showPop: false
        }
    },
    mounted() {
        if (this.lang === 'zh') {
            this.currentIndex = 0
        } else if (this.lang === 'en') {
            this.currentIndex = 1
        } else if (this.lang === 'ja') {
            this.currentIndex = 2
        }
    },
    methods: {
        selectLanuage(item, index) {
            
            if(this.from==='newsDetail'){
                console.log(this.from)
                this.$router.push({ path: `/news-mobile/${item.value}`, query: this.$route.query })
                return
            }else if(this.from === 'product'){
                this.$emit('changeLanuage')
            }
            this.currentIndex = index
            console.log(this.$route)
            const path = this.$route.path.split('/')[1]
            console.log('psth', path)
            if (['zh', 'en', 'ja'].includes(path)) {
                //首页不继续追加语言
                this.$router.push({ path: `/${item.value}`, query: this.$route.query })

            } else {
                this.$router.push({ path: `/${path}/${item.value}`, query: this.$route.query })

            }
        },
        goRouter(item) {
            console.log('router', this.$router)
            this.$router.push({ path: `${item.value}/${this.lang}` })
        }
    }
}
</script>
<style lang="scss" scoped>
.slide-fade-enter-active {
    transition: all 0.5s ease;
}

.slide-fade-leave-active {
    transition: all .5s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}

.slide-fade-enter

/* .slide-fade-leave-active for below version 2.1.8 */
    {
    transform: translateY(-20px);
    opacity: 0;
}

.slide-fade-leave-to {
    transform: translateY(0px);
    opacity: 0;
}

.header-wrap {
    display: flex;
    flex-direction: row;
    background: rgba(0, 0, 0, 0.6);
    height: 1.8rem;
    width: 100%;
    box-sizing: border-box;
    padding: .2rem .32rem;
    justify-content: space-between;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 1000;

    .link-c {
        background: rgba(0, 0, 0, 0.6);
        width: 100%;
        height: 3rem;
        position: absolute;
        top: 1.8rem;
        left: 0;
        padding: .32rem;
        color: #fff;
        font-size: .28rem;

        .item {
            line-height: .5rem;
            text-align: right;
        }

    }

    .right-c {
        display: flex;
        flex-direction: column;
        flex:1;
        .lg-c {
            display: flex;
            flex-direction: row;
            color: #fff;
            font-size: .26rem;
            justify-content: flex-end;
            .la {
                margin-right: .2rem;
            }

            .la:nth-child(3) {
                margin-right: 0;
            }

            .la.on {
                color: rgb(0, 128, 240);
            }
        }

        .ico-more {
            position: relative;
            background: url('../../assets/images/product_ico.png') 0 0 no-repeat;
            background-size: 100%;
            width: .5rem;
            height: .5rem;
            
      
        }

    }

    .logo {
        width: 3.4rem;
        height: 1.2rem;

        img {
            width: 100%;
        }
    }

}</style>